import React from "react";
import { sourcesData } from "../../core/data/json/sources";
import Table from "../../core/common/dataTable/index";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { TableData } from "../../core/data/interface";
import CollapseHeader from "../../core/common/collapse-header";


const Balance = () => {
  const dataSource = sourcesData;
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
       sorter: (a: TableData, b: TableData) =>
        a.title.length - b.title.length,
      key: "title",
      width: "237px",
    },
    {
      title: "Currency Code",
      dataIndex: "extension",
       sorter: (a: TableData, b: TableData) =>
        a.createdAt.length - b.createdAt.length,
      key: "createdAt",
      width: "235px",
    },
    {
      title: "Amount",
      dataIndex: "amount",
       sorter: (a: TableData, b: TableData) =>
        a.createdAt.length - b.createdAt.length,
      key: "createdAt",
      width: "235px",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "90px",
      render: () => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon "
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#edit_source"
            >
              <i className="ti ti-edit text-blue" /> Edit
            </Link>
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_source"
            >
              <i className="ti ti-trash text-danger" /> Delete
            </Link>
          </div>
        </div>
      ),
    },
  ];
  return (
    <>
    {/* Page Wrapper */}
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col-8">
                  <h4 className="page-title">
                  Wallet Amount<span className="count-title">123</span>
                  </h4>
                </div>
                <div className="col-4 text-end">
                  <div className="head-icons">
                   <CollapseHeader/>
                  </div>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="card">
              <div className="card-header">
                {/* Search */}
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <div className="icon-form mb-3 mb-sm-0">
                      <span className="form-icon">
                        <i className="ti ti-search" />
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search Source"
                      />
                    </div>
                  </div>
                  <div className="col-sm-8">
                 
                  </div>
                </div>
                {/* /Search */}
              </div>
              <div className="card-body">
                {/* Contact List */}
                <div className="table-responsive custom-table">
                <Table columns={columns} dataSource={dataSource} />
                </div>
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="datatable-length" />
                  </div>
                  <div className="col-md-6">
                    <div className="datatable-paginate" />
                  </div>
                </div>
                {/* /Contact List */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* /Page Wrapper */}
 
    {/* Edit Source */}
    <div className="modal fade" id="edit_source" role="dialog">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit wallet</h5>
            <button
              className="btn-close custom-btn-close border p-1 me-0 text-dark"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <form >
            <div className="modal-body">
            <div className="input-group mb-3">
              <label className="col-form-label">
               Extension
                </label>
                <div className="mb-2 input-group">
                            <span className="input-group-text"><i className="ti-user"></i></span>
                            <select className="form-select" name="extension" id="extension">
                            <option value="" >Please Select Extension</option>
                                
                                                                <option value="15061 ">Alex Goffery  - 15061</option>
                                
                                
                                                                <option value="18341 ">Allan Corpuz  - 18341</option>
                                
                                
                                                                <option value="18018 ">Anthony Montalvo  - 18018</option>
                                
                                
                                                                <option value="18451 ">Anthony Sandoval  - 18451</option>
                                
                                
                                                                <option value="13926 ">Arya Saliany  - 13926</option>
                                
                                
                                                                <option value="19311 ">Brady Thompson  - 19311</option>
                                
                                
                                                                <option value="13284 ">Brittany Nills  - 13284</option>
                                
                                
                                                                <option value="18009 ">Brittney Tomkalski  - 18009</option>
                                
                                
                                                                <option value="13156 ">Caleb Christensen  - 13156</option>
                                
                                
                                                                <option value="16108 ">Carla Abbasi  - 16108</option>
                                
                                
                                                                <option value="18005 ">Carson Harrison  - 18005</option>
                                
                                
                                                                <option value="18026 ">Charles Ripepe  - 18026</option>
                                
                                
                                                                <option value="18257 ">David Fennell  - 18257</option>
                                
                                
                                                                <option value="18011 ">Donnie Walsh  - 18011</option>
                                
                                
                                                                <option value="16615 ">Enzo David  - 16615</option>
                                
                                
                                                                <option value="16882 ">Ha Nguyen  - 16882</option>
                                
                                
                                                                <option value="14590 ">Harold Libbert  - 14590</option>
                                
                                
                                                                <option value="18063 ">Jacob Nisim  - 18063</option>
                                
                                
                                                                <option value="14776 ">Jishnu T  - 14776</option>
                                
                                
                                                                <option value="12218 ">Ken Howard  - 12218</option>
                                
                                
                                                                <option value="17232 ">Kyle Howard  - 17232</option>
                                
                                
                                                                <option value="16689 ">Landon Liga  - 16689</option>
                                
                                
                                                                <option value="18006 ">Michael Chacon  - 18006</option>
                                
                                
                                                                <option value="16595 ">Nick Harelick  - 16595</option>
                                
                                
                                                                <option value="13909 ">Patrick Mingione  - 13909</option>
                                
                                
                                                                <option value="18555 ">Peter Faggioni  - 18555</option>
                                
                                
                                                                <option value="15077 ">Renewals Development  - 15077</option>
                                
                                
                                                                <option value="18111 ">Richard Romero  - 18111</option>
                                
                                
                                                                <option value="18015 ">Sal Zottoli  - 18015</option>
                                
                                
                                                                <option value="36027 ">Samiksha Agarwal  - 36027</option>
                                
                                
                                                                <option value="13835 ">Sean Maurice  - 13835</option>
                                
                                
                                                                <option value="18007 ">Steve Crosby  - 18007</option>
                                
                                
                                                                <option value="17983 ">Test Test  - 17983</option>
                                
                                
                                                                <option value="13719 ">test test  - 13719</option>
                                
                                
                                                                <option value="11921 ">Test Test  - 11921</option>
                                
                                
                                                                <option value="17316 ">Test Test  - 17316</option>
                                
                                
                                                                <option value="12373 ">Test test2  - 12373</option>
                                
                                
                                                                <option value="13910 ">Tyson Elwood  - 13910</option>
                                
                                
                                                                <option value="13058 ">William Mingione  - 13058</option>
                                
                                
                                                                <option value="15004 ">Zach Christiansen  - 15004</option>
                                
                                
                                                                <option value="17208 ">Zak Grotenstein  - 17208</option>
                                
                                
                            </select>
                            </div>
                            </div>
              <div className="mb-3">
                <label className="col-form-label">
                  Comments 
                </label>
                <textarea  className="form-control" placeholder="Enter comments" />
              </div>
            </div>
            <div className="modal-footer">
              <div className="d-flex align-items-center justify-content-end m-0">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </Link>
                <button type="button" data-bs-dismiss="modal" className="btn btn-primary">
                  Save Changes
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    {/* /Edit Source */}
    {/* Delete Source */}
    <div className="modal fade" id="delete_source" role="dialog">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <div className="text-center">
              <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                <i className="ti ti-trash-x fs-36 text-danger" />
              </div>
              <h4 className="mb-2">Remove Call List?</h4>
              <p className="mb-0">Are you sure you want to remove it.</p>
              <div className="d-flex align-items-center justify-content-center mt-4">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </Link>
                <Link to="#" data-bs-dismiss="modal" className="btn btn-danger">
                  Yes, Delete it
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* /Delete Source */}
  </>
  
  );
};

export default Balance;